import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const registerEcrfFilledPdfReport = async ({
  blobPath,
  totalRows,
  exportRequestId,
  fileSizeBytes,
  signal,
}) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${__API_URL__}/api/reports/register_ecrf_filled_pdf_report/`,
    {
      blob_path: blobPath,
      total_rows: totalRows,
      study_export_request_id: exportRequestId,
      file_size_bytes: fileSizeBytes,
    },
    {
      headers: { Authorization: `Token ${token}` },
      signal,
    }
  );

  return { jobId: response.data.job_id, fileUrl: response.data.file_url };
};

export const useRegisterEcrfFilledPdfReportMutation = () =>
  useMutation({
    mutationFn: ({ blobPath, totalRows, exportRequestId, fileSizeBytes, signal }) =>
      registerEcrfFilledPdfReport({ blobPath, totalRows, exportRequestId, fileSizeBytes, signal }),
  });
